// @flow
import React, { memo, useMemo, useState } from 'react';
import cn from 'classnames';
import { fetchQuery, graphql } from 'react-relay';
import IconImage from 'material-ui/svg-icons/image/image';
import IconStar from 'material-ui/svg-icons/toggle/star';
import IconToday from 'material-ui/svg-icons/action/today';
import IconWhatshot from 'material-ui/svg-icons/social/whatshot';
import IconInfostringOff from 'material-ui/svg-icons/social/notifications-off';
import IconInfostringNotAvailable from 'material-ui/svg-icons/alert/error-outline';
import IconInfostring from 'material-ui/svg-icons/social/notifications';
import IconInfostringHot from 'material-ui/svg-icons/social/notifications-active';
import { sectionPath } from '../../../lib/config';
import modernEnvironment from '../../../lib/RelayUtils';
import * as ArticleEditMutation from '../../../mutations/ArticleEditMutation';
import { titleValidation } from '../../../util/validation';

import './../artlcles-list.css';

const colorDefault = '#777';
const colorInactive = '#000';
const colorActive = '#46bc98';
const colorInfostring = 'blue';
const colorInfostringHot = 'red';
const colorInfostringTooLong = colorDefault;

export const ActionCell = memo((props: Object) => {
	const hasPreviewImage = props.preview && props.preview.type && props.preview.type === 'image';
	const isShownOnMain = props.mainPageOrder > 0;
	const handleToggleClick = (key: string) => event => {
		event.stopPropagation();
		const value = props[key];
		const bool = typeof value === 'undefined' ? value : Boolean(value);
		const newValue = !bool;
		console.log(bool, key, newValue);
		props.handleActionClick(key, props.id, newValue);
	};

	const handleOrderClick = event => {
		event.stopPropagation();
		props.handleActionClick('mainPageOrder', props.id, props.mainPageOrder > 0 ? 0 : 1);
	};

	return (
		<div className="articles--icon">
			{!titleValidation(props.title) ? (
				<div className="articles--icon">
					<div title={'В бегущей строке'} className="articles--icon-item" onClick={handleToggleClick('infostring')}>
						{props.infostring ? (
							<IconInfostring style={{ color: colorInfostring }} />
						) : (
							<IconInfostringOff style={{ color: colorDefault }} />
						)}
					</div>
					<div title={'В бегущей строке - Срочно!'} className="articles--icon-item" onClick={handleToggleClick('infostring_hot')}>
						{props.infostring_hot ? (
							<IconInfostringHot style={{ color: colorInfostringHot }} />
						) : (
							<IconInfostringOff style={{ color: colorDefault }} />
						)}
					</div>
				</div>
			) : (
				<div className="articles--icon">
					<div title={'Заголовок слишком длинный'} className="articles--icon-item">
						<IconInfostringNotAvailable style={{ color: colorInfostringTooLong }} />
					</div>
					<div title={'Заголовок слишком длинный'} className="articles--icon-item">
						<IconInfostringNotAvailable style={{ color: colorInfostringTooLong }} />
					</div>
				</div>
			)}

			<div
				title={hasPreviewImage ? 'В статью добавлена превью фотография' : 'В статье отсутсвует превью фотография'}
				className="articles--icon-item"
			>
				<IconImage style={{ color: hasPreviewImage ? colorActive : colorDefault }} />
			</div>
			<div title="Медиа файлы в статье" className="articles--icon-item">
				<span
					className={
						props.mediaFiles && props.mediaFiles.length > 0
							? 'article--icon article--icon-video is_active'
							: 'article--icon article--icon-video is_disable'
					}
				/>
			</div>
			<div title="Показывать в Я.Дзен" onClick={handleToggleClick('showInYandexZen')} className="articles--icon-item">
				<span
					className={cn('article--icon article--icon-zen', {
						is_active: props.showInYandexZen,
						is_disable: !props.showInYandexZen,
					})}
				/>
			</div>
			<div
				title="Показывать в Я.Новости"
				onClick={handleToggleClick('showInYandexNews')}
				className="articles--icon-item articles--icon-item_yandex"
			>
				<span
					className={cn('article--icon article--icon-yandex', {
						is_active: props.showInYandexNews,
						is_disable: !props.showInYandexNews,
					})}
				/>
			</div>
			{props.section === sectionPath.news && (
				<div title="Главная новость" onClick={handleToggleClick('isMainNews')} className="articles--icon-item">
					<IconStar style={{ color: props.isMainNews ? (props.isActiveBlock ? colorActive : colorInactive) : colorDefault }} />
				</div>
			)}
			<div title="Показ на главной" onClick={handleOrderClick} className="articles--icon-item articles--icon-item_day">
				<IconToday style={{ color: isShownOnMain ? colorActive : colorDefault }} />
			</div>
			<div title="Показывать в сайдбаре" onClick={handleToggleClick('isEvent')} className="articles--icon-item">
				<IconWhatshot style={{ color: props.isEvent ? colorActive : colorDefault }} />
			</div>
		</div>
	);
});

const query = graphql`
	query actionsArticleQuery($id: ID!) {
		viewer {
			article(id: $id) {
				...Article_editFieldsFragment @relay(mask: false)
			}
		}
	}
`;

const toIds = array => array.map(item => item.id);
const toId = item => (item ? item.id : null);
export const ActionCellContainer = (props: Object) => {
	const { configurableBlock } = props;
	const isActiveBlock = configurableBlock && configurableBlock.active;
	const isMainNews = useMemo(() => {
		if (configurableBlock && configurableBlock.type === 'news') {
			const articleId = configurableBlock.config.article.id;
			return props.id === articleId;
		}
		return false;
	}, [configurableBlock]);

	const [state, setState] = useState({
		showInYandexZen: props.showInYandexZen,
		showInYandexNews: props.showInYandexNews,
		isEvent: props.isEvent,
		input: props.infostring,
		infostring_hot: props.infostring_hot,
	});

	// key is string union showInYandexZen | showInYandexNews | showInYandexMirror  | isEvent
	const handleActionClick = (key: string, id: string, newValue) => {
		fetchQuery(modernEnvironment, query, { id: id }).then(response => {
			const { viewer } = response;
			if (viewer.article) {
				const input = { ...viewer.article };

				delete input.foreignAgent;

				['topics', 'linkedArticles', 'mediaFiles'].forEach(key => (input[key] = toIds(viewer.article[key])));
				['preview', 'combinedPreviewVideo'].forEach(key => (input[key] = toId(viewer.article[key])));
				input[key] = newValue;

				if (key === 'infostring' && !newValue) {
					input['infostring_hot'] = false;
				}
				if (key === 'infostring_hot' && newValue) {
					input['infostring'] = true;
				}

				ArticleEditMutation.commit(modernEnvironment, input, () => {
					if (key === 'isMainNews') {
						document.location.reload();
						return;
					}

					const newState = { ...state, [key]: newValue };
					// sync
					if (key === 'infostring' || key === 'infostring_hot') {
						newState['infostring'] = input['infostring'];
						newState['infostring_hot'] = input['infostring_hot'];
					}
					if (props.targetSection === 'infoStrings') {
						props.refetch();
					}
					setState(newState);
				});
			}
		});
	};
	return <ActionCell {...props} {...state} isMainNews={isMainNews} isActiveBlock={isActiveBlock} handleActionClick={handleActionClick} />;
};



// WEBPACK FOOTER //
// src/components/articles/columns/actions.js